<template>
    <v-btn
        class="ml-auto royal-blue lighten-2 px-3 elevation-0"
        style="padding-top: 2px; padding-bottom: 2px; border-radius: 99px; height: unset; min-width: unset;"
    >
        <div class="royal-blue--text caption">
            {{ $t('Elite') }}
        </div>
    </v-btn>
</template>

<script>
export default {
    name: "EliteChip"
};
</script>
